(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const initHeroVideoShell = (shell) => {
    if (!(shell instanceof HTMLElement) || shell.dataset.heroVideoBound === 'true') return;

    const video = shell.querySelector('video');
    const playPauseBtn = shell.querySelector('[data-hero-video-playpause]');
    const muteBtn = shell.querySelector('[data-hero-video-mute]');
    if (!video || !playPauseBtn || !muteBtn) return;

    shell.dataset.heroVideoBound = 'true';

    const playLabel = playPauseBtn.dataset.labelPlay;
    const pauseLabel = playPauseBtn.dataset.labelPause;
    const muteLabel = muteBtn.dataset.labelMute;
    const unmuteLabel = muteBtn.dataset.labelUnmute;

    const syncPlayPause = () => {
      const isPaused = video.paused;
      const playingIcon = playPauseBtn.querySelector('[data-hero-video-state="playing"]');
      const pausedIcon = playPauseBtn.querySelector('[data-hero-video-state="paused"]');
      if (playingIcon) {
        playingIcon.classList.toggle('hero__video-control-icon--hidden', isPaused);
      }
      if (pausedIcon) {
        pausedIcon.classList.toggle('hero__video-control-icon--hidden', !isPaused);
      }
      playPauseBtn.setAttribute('aria-label', isPaused ? playLabel : pauseLabel);
    };

    const syncMute = () => {
      const muted = video.muted;
      const mutedIcon = muteBtn.querySelector('[data-hero-video-state="muted"]');
      const unmutedIcon = muteBtn.querySelector('[data-hero-video-state="unmuted"]');
      if (mutedIcon) {
        mutedIcon.classList.toggle('hero__video-control-icon--hidden', !muted);
      }
      if (unmutedIcon) {
        unmutedIcon.classList.toggle('hero__video-control-icon--hidden', muted);
      }
      muteBtn.setAttribute('aria-label', muted ? unmuteLabel : muteLabel);
    };

    playPauseBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
    });

    video.addEventListener('play', syncPlayPause);
    video.addEventListener('pause', syncPlayPause);
    video.addEventListener('volumechange', syncMute);

    syncPlayPause();
    syncMute();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hero__video-shell').forEach((el) => initHeroVideoShell(el));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('.hero__video-shell').forEach((el) => initHeroVideoShell(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Sync the split colour/size display when Horizon JS updates the hidden variant element
  // (occurs when the selected variant combination is unavailable)
  (function () {
    const COLOUR_OPTION_NAMES = ['color', 'colour', 'colore', 'farbe', 'couleur', 'cor'];

    function getSwatchBgFromPicker(variantPicker, colourOptionIndex) {
      const checkedInputs = Array.from(variantPicker.querySelectorAll('input:checked'));
      const colourInput = checkedInputs[colourOptionIndex];
      if (!colourInput) return null;
      const swatchSpan = colourInput.closest('label')?.querySelector('.swatch');
      if (!swatchSpan) return null;
      return swatchSpan.style.getPropertyValue('--swatch-background').trim() || null;
    }

    function syncStickyVariant(stickyEl) {
      const variantEl = stickyEl.querySelector('.sticky-add-to-cart__variant');
      if (!variantEl) return;

      const colourNameEl = stickyEl.querySelector('.sticky-add-to-cart__variant-colour-name');
      const sizeEl = stickyEl.querySelector('.sticky-add-to-cart__variant-size');
      const swatchEl = stickyEl.querySelector('.sticky-add-to-cart__variant-swatch');
      if (!colourNameEl && !sizeEl) return;

      const title = variantEl.textContent.trim();
      if (!title) return;

      const parts = title.split(' / ');
      const colourIdx = parseInt(stickyEl.dataset.colourOptionIndex || '0');
      const sizeIdx = parseInt(stickyEl.dataset.sizeOptionIndex || '1');

      if (colourNameEl && parts[colourIdx] !== undefined) colourNameEl.textContent = parts[colourIdx];
      if (sizeEl && parts[sizeIdx] !== undefined) sizeEl.textContent = parts[sizeIdx];

      if (swatchEl) {
        const variantPicker = document.querySelector(
          `variant-picker[data-product-id="${stickyEl.dataset.productId}"]`
        );
        if (variantPicker) {
          const bg = getSwatchBgFromPicker(variantPicker, colourIdx);
          if (bg) swatchEl.style.setProperty('--swatch-inner-bg', bg);
        }
      }
    }

    document.querySelectorAll('sticky-add-to-cart').forEach((stickyEl) => {
      const variantEl = stickyEl.querySelector('.sticky-add-to-cart__variant');
      if (!variantEl) return;

      new MutationObserver(() => syncStickyVariant(stickyEl)).observe(variantEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twp-pdp-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.twp-collection-carousel__track').forEach((track) => {
    const scroller = track.querySelector('.twp-collection-carousel__scroller');
    const prevBtn = track.querySelector('.twp-collection-carousel__arrow--prev');
    const nextBtn = track.querySelector('.twp-collection-carousel__arrow--next');

    function scrollAmount() {
      const item = scroller.querySelector('.twp-collection-carousel__item');
      return item ? (item.offsetWidth + 8) * 2 : 500;
    }

    function updateArrows() {
      prevBtn.hidden = scroller.scrollLeft <= 0;
      nextBtn.hidden = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 1;
    }

    prevBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twp-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-yotpo-testimonial]');
    if (!section) return;

    const appKey = section.dataset.appKey;
    const reviewIndex = parseInt(section.dataset.reviewIndex, 10) || 0;
    const inner = section.querySelector('.testimonial__inner');
    const contentEl = section.querySelector('.testimonial__content');
    const authorEl = section.querySelector('.testimonial__author');
    const stars = section.querySelectorAll('.testimonial__star');

    fetch(`https://api.yotpo.com/v1/apps/${appKey}/reviews?count=${reviewIndex + 1}&page=1`)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const reviews = (data.response || data).reviews;
        if (!reviews || !reviews.length) return;

        const review = reviews[reviewIndex] || reviews[reviews.length - 1];
        const score = Math.round(review.score || 5);
        const content = review.content || '';
        const author = (review.user && review.user.display_name) || '';

        stars.forEach(function (star, i) {
          star.classList.toggle('testimonial__star--filled', i < score);
        });

        contentEl.textContent = '“' + content + '”';
        authorEl.textContent = author;

        inner.removeAttribute('aria-hidden');
        inner.classList.remove('testimonial__inner--loading');
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
